import Vue from 'vue'
import Vuex from 'vuex'
import { reconcileBill } from './vuexModules'
import http from '@/lib/http'
import { api } from '@/api/apiList'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    reconcileBill,
  },
  state: {
    uacStatus: false,
    uacRouteNameList: [],
    uacApiAuth: [],
    loginName: '',
  },
  mutations: {
    updateUacRouteNameList(state, data) {
      state.uacRouteNameList = data
    },
    updateUacStatus(state, data) {
      state.uacStatus = data
    },
    updateUacAuth(state, data) {
      state.uacApiAuth = data
    },
    updateLoginUserName(state, data) {
      state.loginName = data
    },
  },
  actions: {
    getUacAuth({ commit }) {
      http
        .post(api.getAuthUrls, [
          '/api/partner/outside/platform/staff/openUserAccount',
          '/api/partner/outside/platform/staff/reOpenAccount',
          '/api/partner/outside/platform/staff/editAuthority',
          '/api/partner/outside/platform/staff/accountStopUse',
          '/api/partner/outside/platform/staff/accountRecover',
          '/api/partner/outside/platform/staff/quitStaff',
          '/api/partner/outside/platform/agent/settlementOrder/supplier/query/pageList',
          '/api/partner/outside/platform/agent/settlementOrder/supplier/confirm',
        ])
        .then(res => {
          const auth = []
          res.data.forEach(el => {
            if (el.authResult) auth.push(el.url)
          })
          commit('updateUacAuth', auth)
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
})
